import * as React from "react";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { useTitle } from "../../hooks/useTitle";
import ProjectGrid from "./ProjectGrid";
import ProjectDrawer from "./ProjectDrawer";
import { ProjectStatus } from "../../types/project";
import qs from "qs";
import ProjectGridClient from "./ProjectGridClient";

interface TabPanelProps {
  children?: React.ReactNode;
  dir?: string;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

const ProjectPage = () => {
  useTitle("Jobs");

  const theme = useTheme();
  const [value, setValue] = React.useState(1);
  const [open, setOpen] = React.useState(false);
  const [currentItem, setCurrentItem] = React.useState(null);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  React.useEffect(() => {
    const params = qs.parse(window.location.href.split("?")[1]);
    console.log(params);
    if (params.t) {
      setValue(Number(params.t));
    }
  }, []);
  return (
    <Box
      sx={{
        bgcolor: "background.paper",
        width: "auto",
      }}
    >
      <Tabs
        value={value}
        onChange={handleChange}
        indicatorColor="primary"
        textColor="primary"
        variant="fullWidth"
      >
        <Tab label="Draft" {...a11yProps(0)} />
        <Tab label="In-Progress" {...a11yProps(1)} />
        <Tab label="Completed" {...a11yProps(2)} />
        <Tab label="Canceled" {...a11yProps(3)} />
      </Tabs>
      <TabPanel value={value} index={0} dir={theme.direction}>
        <ProjectGrid
          status={ProjectStatus.DRAFT}
          onView={(item) => {
            setCurrentItem(item);
            setOpen(true);
          }}
        />
      </TabPanel>
      <TabPanel value={value} index={1} dir={theme.direction}>
        <ProjectGridClient
          statuses={[
            ProjectStatus.PUBLISHED,
            ProjectStatus.SCHEDULED,
            ProjectStatus.IN_PROGRESS,
          ]}
          onView={(item) => {
            setCurrentItem(item);
            setOpen(true);
          }}
        />
      </TabPanel>
      <TabPanel value={value} index={2} dir={theme.direction}>
        <ProjectGrid
          status={ProjectStatus.COMPLETED}
          onView={(item) => {
            setCurrentItem(item);
            setOpen(true);
          }}
        />
      </TabPanel>
      <TabPanel value={value} index={3} dir={theme.direction}>
        <ProjectGrid
          status={ProjectStatus.CANCELED}
          onView={(item) => {
            setCurrentItem(item);
            setOpen(true);
          }}
        />
      </TabPanel>
      <ProjectDrawer data={currentItem!} open={open} setOpen={setOpen} />
    </Box>
  );
};
export default ProjectPage;
